export type SupportedLanguagesType = "en-GB" | "ar-SA"

export const SUPPORTED_LANGUAGES: SupportedLanguagesType[] = ["en-GB", "ar-SA"]

export const LANGUAGES: { code: SupportedLanguagesType; lang: string }[] = [
  { code: "en-GB", lang: "English" },
  { code: "ar-SA", lang: "عربي" },
] as const
